import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';

export const FixedMenu = {
    computed: {
        ...mapState(vplSiteStore, ['menu'])
    },
    template: `
        <div v-if="this.menu.fixed" class="burger__dropdown-links">
            <a v-for="menuItem in this.menu.fixed.ITEMS" :href="menuItem.LINK" class="burger__dropdown-links-item">{{ menuItem.TEXT }}</a>
            <button v-if="this.menu.top.EDIT_BUTTON" :onclick="this.menu.top.EDIT_BUTTON">Редактировать пункты меню</button>
        </div>
    `
}